import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/building-blocks/bar-vertical/bar-vertical.js';
      import {ExternalScaleSide, BarContainerStyle, ScaleType, FillMode, AdvicePosition} from '@oicl/openbridge-webcomponents/dist/building-blocks/external-scale/external-scale.js';
import {FrameStyle, BorderRadiusPosition, Priority, InstrumentState} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/types.js';
import {AdviceType} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/watch/advice.js';

      export interface Props {
     minValue?: number;
     maxValue?: number;
     height?: number;
     paddingTop?: number;
     paddingBottom?: number;
     side?: ExternalScaleSide;
     fixedAspectRatio?: boolean;
     scaleReferenceSize?: number;
     hasScale?: boolean;
     showLabels?: boolean;
     hasBar?: boolean;
     scaleBackground?: boolean;
     barContainerStyle?: BarContainerStyle | undefined;
     barThickness?: number;
     tickThickness?: number;
     labelThickness?: number;
     mainTickmarks?: number[] | undefined;
     primaryTickmarkInterval?: number | undefined;
     secondaryTickmarkInterval?: number | undefined;
     tertiaryTickmarkInterval?: number | undefined;
     scaleType?: ScaleType;
     frameStyle?: FrameStyle;
     borderRadiusPosition?: BorderRadiusPosition | undefined;
     instrumentMode?: boolean;
     borderRadius?: number | undefined;
     priority?: Priority;
     fillMode?: FillMode;
     fillMin?: number | undefined;
     fillMax?: number | undefined;
     value?: number | undefined;
     state?: InstrumentState;
     advicePosition?: AdvicePosition;
     advices?: { min: number; max: number; type: AdviceType; hinted: boolean; }[] | undefined;
     highlightCurrentValue?: boolean;
     setpoint?: number | undefined;
     newSetpoint?: number | undefined;
     atSetpoint?: boolean;
     touching?: boolean;
     autoAtSetpoint?: boolean;
     autoAtSetpointDeadband?: number;
     setpointAtZeroDeadband?: number;
     setpointOverride?: boolean;
     animateSetpoint?: boolean
   }

      
  
      export type {ExternalScaleSide, BarContainerStyle, ScaleType, FillMode, AdvicePosition} from '@oicl/openbridge-webcomponents/dist/building-blocks/external-scale/external-scale.js';
export type {FrameStyle, BorderRadiusPosition, Priority, InstrumentState} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/types.js';
export type {AdviceType} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/watch/advice.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcBarVertical',
  props: {
    minValue: {},
    maxValue: {},
    height: {},
    paddingTop: {},
    paddingBottom: {},
    side: {},
    fixedAspectRatio: { type: Boolean },
    scaleReferenceSize: {},
    hasScale: { type: Boolean },
    showLabels: { type: Boolean },
    hasBar: { type: Boolean },
    scaleBackground: { type: Boolean },
    barContainerStyle: {},
    barThickness: {},
    tickThickness: {},
    labelThickness: {},
    mainTickmarks: {},
    primaryTickmarkInterval: {},
    secondaryTickmarkInterval: {},
    tertiaryTickmarkInterval: {},
    scaleType: {},
    frameStyle: {},
    borderRadiusPosition: {},
    instrumentMode: { type: Boolean },
    borderRadius: {},
    priority: {},
    fillMode: {},
    fillMin: {},
    fillMax: {},
    value: {},
    state: {},
    advicePosition: {},
    advices: {},
    highlightCurrentValue: { type: Boolean },
    setpoint: {},
    newSetpoint: {},
    atSetpoint: { type: Boolean },
    touching: { type: Boolean },
    autoAtSetpoint: { type: Boolean },
    autoAtSetpointDeadband: {},
    setpointAtZeroDeadband: {},
    setpointOverride: { type: Boolean },
    animateSetpoint: { type: Boolean }
  },
  setup(__props: any) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-bar-vertical',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})